<template>
  <v-container>
    <v-row class="text-center my-5">
      <v-col class="mb-5" cols="12">
        <TenantsCard />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TenantsCard from "./Categories/TenantsCard.vue";
export default {
  components: {
    TenantsCard,
  },
};
</script>
